import type { IconSvgObject } from './types';

const ChevronFirstIcon: IconSvgObject = [
  ["path", { d: "M7 6V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 18C17 18 11 13.5811 11 12C11 10.4188 17 6 17 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChevronFirstIcon;
